import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithLogoutGuard } from "../../common/createBaseQueryWithLogoutGuard";
import store from "../../../app/store";
 
export const _authToken = () => {
  const state = store.getState();
  return `${state?.authReducer?.userData?.tokenType?.toLowerCase()} ${
    state?.authReducer?.userData?.accessToken
  }`;
};
export const _orgClientId = () => {
  const state = store.getState();
  return state?.orgReducer?.selectedFI?.orgClientId
    ? state?.orgReducer?.selectedFI?.orgClientId
    : state?.authReducer?.userData?.clientId;
};
 
// ---------------------------------------------------------
// RTK Query API
// ---------------------------------------------------------
export const notificationRTK = createApi({
  reducerPath: "notificationRTK",
  baseQuery: createBaseQueryWithLogoutGuard({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["NotificationRTK"],
  endpoints: (builder) => ({
    // ----------------------------------------
    // GET NOTIFICATION LIST
    // ----------------------------------------
    getNotificationList: builder.query({
      query: () => ({
        url: `/${_orgClientId()}/notification`,
        method: "GET",
        headers: {
          Authorization: _authToken(),
          "Content-Type": "application/json",
        },
      }),
      providesTags: ["NotificationRTK"],
    }),
    // ----------------------------------------
    // READ ALL NOTIFICATIONS (PUT)
    // ----------------------------------------
    readAllNotificationList: builder.mutation({
      query: ({ payloadObject }) => ({
        url: `/${_orgClientId()}/notification`,
        method: "PUT",
        headers: {
          Authorization: _authToken(),
          "Content-Type": "application/json",
        },
        body: payloadObject,
      }),
      invalidatesTags: ["NotificationRTK"], // auto refetch list
    }),
  }),
});
 
export const {
  useGetNotificationListQuery,
  useLazyGetNotificationListQuery,
  useReadAllNotificationListMutation,
} = notificationRTK;